import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IConduit } from '@rfm/shared-interfaces';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConduitService } from '../../../../../shared/services/fiber-management/conduit.service.mjs';
interface Order {
  client: string;
  date: string;
  order: string;
  items: string;
  total: string;
  status: string;
}
@Component({
  selector: 'app-conduit-create',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    TextareaModule,
    ButtonModule,
    ProgressSpinnerModule,
    DialogModule,
    CalendarModule,
    DropdownModule,
  ],
  templateUrl: './conduit-create.component.html',
  styleUrls: ['./conduit-create.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class ConduitCreateComponent implements OnInit {
  @Input() displayTaskModal: boolean = false;
  @Input() order: Order | null = null;
  @Output() closeTaskModal = new EventEmitter<void>();
  conduitForm!: FormGroup;
  isLoading = false;
  taskForm = new FormGroup({
    serviceName: new FormControl(''),
    clientName: new FormControl('Kathryn Murphy'),
    dueDate: new FormControl(new Date()),
    status: new FormControl('Paid'),
    items: new FormControl(2),
    total: new FormControl('$0'),
    orderId: new FormControl('#0145'),
  });
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private conduitService: ConduitService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(): void {
    this.conduitForm = this.fb.group({
      size: ['', Validators.required],
      status: ['', Validators.required],
      coordinates: ['', Validators.required],
      handholeId_start: ['', Validators.required],
      handholeId_end: ['', Validators.required],
      couplings: [''],
      notes: [''],
    });
  }

  onSubmit(): void {
    if (this.conduitForm.valid) {
      const newConduit: IConduit = this.conduitForm.value;
      this.isLoading = true;

      this.conduitService.insert(newConduit)
        .then(() => {
          console.log('Conduit created successfully');
          this.router.navigate(['/conduit/list']);
        })
        .catch((error) => {
          console.error('Error creating conduit:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  clientPhoto = 'https://plus.unsplash.com/premium_photo-1690407617542-2f210cf20d7e?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'; // Replace with actual image URL

  statusOptions = [
    { label: 'Paid', value: 'Paid' },
    { label: 'Unpaid', value: 'Unpaid' },
  ];

  itemOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
  ];

  saveChanges() {
    console.log('Saving:', this.order);
    this.closeTaskModal.emit();
  }
}
